<section>
  <iframe *ngIf="iframeURL" [src]="iframeURL" frameborder="0"></iframe>
</section>
